import { render, staticRenderFns } from "./issueRes.vue?vue&type=template&id=241d96e8&scoped=true"
import script from "./issueRes.vue?vue&type=script&lang=js"
export * from "./issueRes.vue?vue&type=script&lang=js"
import style0 from "./issueRes.vue?vue&type=style&index=0&id=241d96e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241d96e8",
  null
  
)

export default component.exports